// extracted by mini-css-extract-plugin
export default {"header":"header_header__zhJh1","holder":"header_holder__LQcrJ","logo":"header_logo__dXpSz","nav":"header_nav__O9ofa","navMobile":"header_navMobile__0juks"};